import { getApiBaseUrl } from '../auth/apiBaseUrl';

/** AI report generation — separate from the Reimagine backend API. */
const REIMAGINE_LITE_REPORT_URL =
  'https://ai.traxccel.com/reimaginelite/api/ui/reimagine-lite-report';

function joinApiPath(base: string, path: string): string {
  const normalizedBase = base.replace(/\/$/, '');
  const normalizedPath = path.replace(/^\//, '');
  return `${normalizedBase}/${normalizedPath}`;
}

export const getReimagineLiteReport = async (userDetails, cardAnswers) => {
    try {
      console.log("Fetching Reimagine Lite Report...");
      
      // Map card categories to section names
      const sectionMapping = {
        'project-type': 'Business Strategy & Vision Alignment',
        'maturity': 'Business readiness',
        'sector': 'AI Readiness & Adoption Strategy',
        'function': 'Technology Readiness',
        'capability': 'Data Readiness',
        'impact': 'Risk Management & Governance',
        'dummy1': 'Talent readiness',
        'dummy2': 'Impact, Value & Performance Measurement',
        'dummy3': 'Cost effectiveness'
      };
  
      // Map card categories to question texts
      const questionMapping = {
        'project-type': 'Do you have an data+AI strategy aligned with business goals and supported by a clear vision?',
        'maturity': 'Is the business committed to AI initiative and what it will take on their part?',
        'sector': 'Have you identified key AI use cases, and is there a plan for adoption across teams?',
        'function': 'Is your technology ecosystem ready to support AI initiatives?',
        'capability': 'Do you have the trustworthy data (internal, external, or third-party) to support AI use cases?',
        'impact': 'Do you have governance frameworks in place to ensure ethical and secure AI deployment?',
        'dummy1': 'Are your teams equipped with the right domain expertise and technical skills to effectively adopt and leverage AI tools?',
        'dummy2': 'Do you have metrics to track the impact, ROI, and performance of your AI initiatives?',
        'dummy3': 'Is the required funding available to initiate and scale AI transformation?'
      };
  
      // Build QuestionnaireResponse object
      const questionnaireResponse = {};
      
      Object.keys(cardAnswers).forEach(category => {
        const sectionName = sectionMapping[category];
        const questionText = questionMapping[category];
        const answer = cardAnswers[category];
  
        if (sectionName && questionText && answer) {
          questionnaireResponse[sectionName] = {
            questions: [
              {
                [questionText]: answer
              }
            ]
          };
        }
      });
  
      // Build request body
      const requestBody = {
        website_url: userDetails.companyUrl || '',
        QuestionnaireResponse: questionnaireResponse
      };
  
      console.log("Request body being sent to API:", requestBody);

      const response = await fetch(REIMAGINE_LITE_REPORT_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
      });
      if (!response.ok) {
        const errorText = await response.text();
        console.error("Error response from API:", errorText);
        throw new Error(`Failed to fetch Reimagine Lite Report: ${response.status} ${response.statusText}`);
      }
      const result = await response.json();
      console.log("Reimagine Lite Report response:", result);
      return result;
    } catch (error) {
      console.error("Error fetching Reimagine Lite Report:", error.message || error);
      throw error;
    }
  };

export const addReimagineLiteReport = async (userDetails) => {
  try {
    console.log("Adding Reimagine Lite Report to database...");
    
    // Build request body
    const requestBody = {
      name: userDetails.name || '',
      email: userDetails.email || '',
      companyName: userDetails.companyName || '',
      companyUrl: userDetails.companyUrl || ''
    };

    console.log("Request body being sent to database API:", requestBody);
    
    const addUrl = joinApiPath(
      getApiBaseUrl(),
      'ReimagineLiteReport/AddReimagineLiteReport'
    );
    const response = await fetch(addUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error("Error response from database API:", errorText);
      throw new Error(`Failed to add Reimagine Lite Report: ${response.status} ${response.statusText}`);
    }

    const result = await response.json();
    console.log("Reimagine Lite Report added successfully:", result);
    return result;
  } catch (error) {
    console.error("Error adding Reimagine Lite Report:", error.message || error);
    throw error;
  }
};